import React, { PureComponent } from 'react';
import ChipsItem from 'ui/form/chips/chips-item';
import ChipsListProps from '../fields';

interface ChipsListState {}
export default class ChipsList extends PureComponent<ChipsListProps, ChipsListState> {
  // Compares to arrays and makes chips from the matches
  static getMatchedChips = (list, value, mapping) => {
    const chipsList = new Array(value ? value.length : 0);
    if (list.length && value) {
      for (let item of list) {
        const listValue = item;
        const index = value
          .map(function(e) {
            return e[mapping.text];
          })
          .indexOf(listValue[mapping.text] || listValue);
        if (index !== -1) {
          chipsList[index] = {
            label: listValue[mapping.text] || '',
            value: listValue[mapping.text],
            icon: listValue[mapping.image] || ''
          };
        }
      }
    }
    return chipsList;
  };
  
  handleRemove = (value: string) => {
    const { onRemove } = this.props;
    if (onRemove) onRemove(value);
  };
  render() {
    const { value } = this.props;
    if (!value) return false;
    return value.map((chip, i) => {
      return <ChipsItem {...chip} onRemove={this.handleRemove} key={i} />;
    });
  }
}
